import { useCallback, useState } from 'react';

import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { Button } from 'UIPackage/MainModule/components/Button';

import { IFilterWithMeta } from '../interfaces/IFilterWithMeta';
import { FilterDeleteModal } from './FilterDeleteModal';
import styles from './FiltersModalNavigation.module.scss';

interface IFiltersModalNavigationProps<Filter> {
  filters: IFilterWithMeta<Filter>[];
  newFilterName: string;
  activeTemplateId?: IFilterResult['id'];
  fieldsFillCount: number;
  onTemplateCreate: () => void;
  onActiveTemplateChange: (id: IFilterResult['id']) => void;
  removeFilter: (id: IFilterResult['id']) => void;
}

export function FiltersModalNavigation<Filter>({
  filters,
  newFilterName,
  activeTemplateId,
  fieldsFillCount,
  onTemplateCreate,
  onActiveTemplateChange,
  removeFilter,
}: IFiltersModalNavigationProps<Filter>) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filter, setFilter] = useState<IFilterResult>();

  const onModalApply = useCallback(() => removeFilter(filter?.id || 0), [filter?.id, removeFilter]);
  const onModalClose = useCallback(() => setIsModalVisible(false), []);

  const makeOnDeleteClick = (meta: IFilterResult) => () => {
    setFilter(meta);
    setIsModalVisible(true);
  };

  const makeOnTemplateClick = (id: IFilterResult['id']) => () => {
    onActiveTemplateChange(id);
  };

  return (
    <div className={styles.FilterNav}>
      <div className={styles.FilterNavTitle}>
        {newFilterName}&nbsp;<small className={styles.FilterNavTitleNumber}>({fieldsFillCount})</small>
      </div>

      <div className={styles.FilterNavSavedTitle}>
        Сохраненные фильтры <small className={styles.FilterNavTitleNumber}>({filters?.length})</small>
      </div>

      <div className={styles.FilterTemplates}>
        {filters.map(({ meta }) => {
          const filterAttributes = {
            ...(activeTemplateId === meta.id && { 'data-active': true }),
          };

          return (
            <div className={styles.FilterTemplate} {...filterAttributes} key={meta.id}>
              <button className={styles.FilterTemplateButton} type="button" onClick={makeOnTemplateClick(meta.id)}>
                {meta.name}
              </button>
              <button className={styles.FilterTemplateDeleteButton} type="button" onClick={makeOnDeleteClick(meta)} />
            </div>
          );
        })}
      </div>

      <div className={styles.FilterNavCreateButtonBlock}>
        <Button text="Создать фильтр" id="createButton" color="primary" onClick={onTemplateCreate} />
      </div>

      <FilterDeleteModal
        visible={isModalVisible}
        name={filter?.name || ''}
        onApply={onModalApply}
        onClose={onModalClose}
      />
    </div>
  );
}
